/* External */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { List } from 'immutable';

/* Storage */
import { selectContentsListByIdsList } from '../storage/contents';

/* Utils */
import createCachedListSelectorHook from './createCachedListSelectorHook';

function useSeasonEpisodesSimple(season, sourceProvider) {
  const seasonEpisodesList = (season?.episodes ?? []).map((episode) => (sourceProvider ? `${episode}-${sourceProvider}` : episode));

  const seasonEpisodesSelector = useMemo(
    () => selectContentsListByIdsList(seasonEpisodesList),
    [seasonEpisodesList],
  );
  return useSelector(seasonEpisodesSelector) || List();
}

const useSeasonEpisodes = createCachedListSelectorHook(useSeasonEpisodesSimple);

export default useSeasonEpisodes;
